module.exports = __webpack_public_path__ + "img/12.42bc0480.jpg";